import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { FlaskConical, Loader2, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Crea o retira datos de ejemplo SOLO dentro de una campaña, sin tocar los reales. */
export const DemoDataButton = ({ campaign }) => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/campaigns/${campaign.id}/demo-data`);
      setStatus(data);
    } catch { /* silencioso */ }
  }, [campaign.id]);

  useEffect(() => { load(); }, [load]);

  const create = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/campaigns/${campaign.id}/demo-data`);
      data.status === 'already_created'
        ? toast.info('Esta campaña ya tiene datos de ejemplo')
        : toast.success(`Ejemplo listo: ${data.customers} clientes, ${data.chats} chats y ${data.products} productos`);
      await load();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'No se pudo crear el ejemplo');
    } finally {
      setBusy(false);
    }
  };

  const remove = async () => {
    setBusy(true);
    try {
      const { data } = await axios.delete(`${API}/campaigns/${campaign.id}/demo-data`);
      toast.success(`Ejemplo retirado (${data.customers} clientes, ${data.chats} chats)`);
      await load();
    } catch {
      toast.error('No se pudo retirar el ejemplo');
    } finally {
      setBusy(false);
    }
  };

  return status?.has_demo ? (
    <Button variant="outline" size="sm" onClick={remove} disabled={busy}
      data-testid={`campaign-demo-remove-${campaign.id}`}
      className="border-destructive/40 text-destructive hover:bg-destructive/10">
      {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Trash2 className="w-4 h-4 mr-1" />}
      Quitar ejemplo
    </Button>
  ) : (
    <Button variant="outline" size="sm" onClick={create} disabled={busy}
      data-testid={`campaign-demo-${campaign.id}`}
      className="border-brand-green/40 text-brand-green hover:bg-brand-green/10">
      {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <FlaskConical className="w-4 h-4 mr-1" />}
      Datos de ejemplo
    </Button>
  );
};

export default DemoDataButton;
